import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  onBack: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onBack }) => {
  const { t } = useTranslation();

  return (
    <div
      data-test-id="error-state"
      className="h-full bg-surface flex flex-col items-center justify-center p-4"
    >
      <p data-test-id="error-message" className="text-muted-foreground mb-4">
        {t('competition.error.notFound')}
      </p>
      <Button data-test-id="go-back-btn" variant="secondary" onClick={onBack}>
        {t('actions.goBack')}
      </Button>
    </div>
  );
};
